import { toast } from "sonner";
import { requestFocusTrend, type ToastPlan } from "@/lib/trendNotifications";

/** Headline used for the toast, the history entry, and the email/push payload. */
export function trendToastTitle(plan: ToastPlan): string {
  if (plan.kind === "none") return "";
  if (plan.kind === "summary") {
    return `Daily summary: ${plan.ids.length} new curated trends`;
  }
  return plan.ids.length === 1
    ? "1 new curated trend just landed"
    : `${plan.ids.length} new curated trends just landed`;
}

/**
 * Renders the new-trend toast for a plan produced by `planTrendToast`.
 * The action button jumps straight to the newly curated trend in the feed.
 */
export function showNewTrendToast(plan: ToastPlan): void {
  if (plan.kind === "none" || plan.ids.length === 0) return;
  const first = plan.ids[0];

  toast.success(trendToastTitle(plan), {
    description:
      plan.kind === "summary"
        ? "Collected since your last summary."
        : "Your feed and stat cards are up to date.",
    action: {
      label: plan.ids.length === 1 ? "View trend" : "View trends",
      onClick: () => requestFocusTrend(first),
    },
  });
}

/**
 * Dev/e2e hook: lets Playwright trigger a real new-trend toast without having
 * to insert rows into the database. Only registered outside production.
 */
export function registerNewTrendToastTestHook(): void {
  if (import.meta.env.PROD) return;
  (window as any).__tdShowNewTrendToast = (ids: string[] = ["test-trend"]) =>
    showNewTrendToast({ kind: "instant", ids });
}
